import type { PieceType, Team, WinReason } from '@halvard/rules';

export const PIECE_RULES: Readonly<Record<PieceType, string>> = {
  B: 'Moves 1 square in any direction. Protect it, or hold the summit with it.',
  C: 'Moves 1 or 2 squares straight. Can scale a 2-level cliff, which ends its move.',
  X: 'Jumps in an L over anything. Lands at most 1 level higher.',
  L: 'Steps 1 square straight, or pins an enemy 2–3 squares away in its line of sight.',
  M: 'Steps 1 square any way, or raises or lowers an empty neighbouring square.',
};

export const TEAM_LABEL: Readonly<Record<Team, string>> = { I: 'Ivory', B: 'Basalt' };

/** Banner text for a finished game. */
export function resultText(
  winner: Team | null,
  reason: WinReason,
): { title: string; detail: string } {
  if (winner === null) {
    const detail =
      reason === 'repetition'
        ? 'The same position came up three times.'
        : reason === 'move-limit'
          ? 'The move limit was reached.'
          : 'Both players agreed to a draw.';
    return { title: 'Draw', detail };
  }
  const name = TEAM_LABEL[winner];
  const loser = TEAM_LABEL[winner === 'I' ? 'B' : 'I'];
  const details: Readonly<Record<WinReason, string>> = {
    capture: `${name} captured the ${loser} Beacon.`,
    summit: `${name} held the summit for a full turn.`,
    stuck: `${loser} had no legal move left.`,
    resign: `${loser} resigned.`,
    timeout: `${loser} ran out of time.`,
    agreement: '',
    repetition: '',
    'move-limit': '',
  };
  return { title: `${name} wins`, detail: details[reason] };
}
